
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/_open-gelderland/woo-documenten",
      function () {
        return require("private-next-pages/_sites/_open-gelderland/woo-documenten/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/_open-gelderland/woo-documenten"])
      });
    }
  